<template>
  <v-app>
    <v-overlay
      :z-index="$vuetify.breakpoint.smAndDown ? 4 : 5"
      :opacity="1"
      color="primary"
      :value="loading"
    >
      <v-progress-circular color="white" indeterminate :size="100" :width="6">
        <v-icon size="70">icon-letrai32</v-icon>
      </v-progress-circular>
    </v-overlay>
    <navigation v-if="$route.name !== 'auth-login'" />
    <router-view />
    <v-footer v-if="$route.name !== 'auth-login'" class="main-footer">
      <v-col class="text-center py-1 caption" cols="12">
        <strong>
          &copy; 2018 - {{ new Date().getFullYear() }} IPrintPOS.
        </strong>
        {{ $tc('copyright') }}
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import Navigation from './components/navigation/Toolbar.vue'
import tinycolor from 'tinycolor2'

export default {
  name: 'App',
  components: {
    Navigation
  },
  computed: {
    ...mapGetters({
      loading: 'utils/getIsloading',
      colors: 'company/getCompanyData',
      darkMode: 'session/darkMode'
    })
  },
  methods: {
    updateRootColors() {
      const currentColors = this.$store.getters['company/getCompanyData']
      const currentDarkMode = this.$vuetify.theme.dark

      if (currentColors && currentColors.primary_color) {
        const root = document.documentElement
        const primary =
          (tinycolor(currentColors.primary_color).getBrightness() <= 80 &&
            currentDarkMode) ||
          (tinycolor(currentColors.primary_color).getBrightness() >= 220 &&
            !currentDarkMode)
            ? '#3073C9'
            : currentColors.primary_color

        const secondary =
          (tinycolor(currentColors.secondary_color).getBrightness() <= 80 &&
            currentDarkMode) ||
          (tinycolor(currentColors.secondary_color).getBrightness() >= 220 &&
            !currentDarkMode)
            ? '#345d48'
            : currentColors.secondary_color

        const darkText = tinycolor(currentColors.primary_color).isDark()
        const secondaryText = tinycolor(secondary).isDark()

        root.style.setProperty('--primary', primary)
        root.style.setProperty('--secundary', secondary)
        root.style.setProperty('--text-color', darkText ? '#fff' : '#000')
        root.style.setProperty(
          '--text-color-secondary',
          secondaryText ? '#fff' : '#000'
        )

        if (this.$vuetify) {
          this.$vuetify.theme.themes.light.primary = primary
          this.$vuetify.theme.themes.dark.primary = primary
          this.$vuetify.theme.themes.light.secondary = secondary
          this.$vuetify.theme.themes.dark.secondary = secondary
        }
      } else {
        const root = document.documentElement
        const primary = '#3073C9'
        const secondary = '#345d48'

        root.style.setProperty('--primary', primary)
        root.style.setProperty('--secundary', secondary)
        root.style.setProperty('--text-color', '#fff')
        root.style.setProperty('--text-color-secondary', '#fff')

        if (this.$vuetify) {
          this.$vuetify.theme.themes.light.primary = primary
          this.$vuetify.theme.themes.dark.primary = primary
          this.$vuetify.theme.themes.light.secondary = secondary
          this.$vuetify.theme.themes.dark.secondary = secondary
        }
      }
    }
  },
  mounted() {
    this.$store.subscribe((mutation) => {
      if (
        mutation.type === 'company/companyData' ||
        mutation.type === 'company/resetCompany'
      ) {
        this.updateRootColors()
      }
    })
  },
  watch: {
    '$vuetify.theme.dark': {
      handler: 'updateRootColors',
      immediate: true
    }
  }
}
</script>
<style lang="sass">
.v-footer.main-footer
  color: var(--v-auxtext-base)
  background-color: var(--v-auxbg-base)
</style>
